window.__WWAI__ = window.__WWAI__ || {};
    
// Environment + Mode Config
// Use metafield-based subscription in sandbox/local
window.__WWAI__.useMockSubscription = false;

// Options: "local" | "sandbox" | "prod"
window.__WWAI__.deployMode = "prod";

// Enables dev/debugger mode, values are dev, prod
window.__WWAI__.MODE = "prod";

// Controls Liquid-product rendering
window.__WWAI__.RENDER_WITH_LIQUID = true;

// Which connector to use for hydration
window.__WWAI__.CONNECTOR_TYPE = "shopify";

// Enable logging for grid height debugging
window.__WWAI__.heightEqualizeLogging = true;

// Currency Config
// Active currency from Shopify
window.__WWAI__.CURRENCY = Shopify.currency.active;

// Currency conversion factor
window.__WWAI__.CURRENCY_FACTOR = 0.01;

// Product mapping object
window.__WWAI__.JS_PRODUCT_MAPPING_OBJECT = {};

// Product group config
window.__WWAI__.WWAI_PRODUCT_GROUP_CONFIG = {
  "dr_idriss_pdp_jy6D4Q": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "checkout",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "major-fade-solution-system-sticky": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "major-fade-solution-system",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "major-fade-solution-system",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    },
    "major-fade-solution-system": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "major-fade-solution-system",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "major-fade-solution-system",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    }
  },
  "dr_idriss_products_XFRGCN": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "checkout",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "the-depuffer-arnica-roll-on-serum": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "the-depuffer-arnica-roll-on-serum",
        "defaultVariantOption1": "1.35 oz / 40 mL",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "the-depuffer-arnica-roll-on-serum",
        "allOptions": {
          "option1": "1.35 oz / 40 mL",
          "option2": "",
          "option3": ""
        }
      }
    },
    "soft-wash": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "soft-wash",
        "defaultVariantOption1": "5.2 oz / 154 mL",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "soft-wash",
        "allOptions": {
          "option1": "5.2 oz / 154 mL",
          "option2": "",
          "option3": ""
        }
      }
    },
    "barrier-baste-lip-basting-duo": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "barrier-baste-lip-basting-duo",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "barrier-baste-lip-basting-duo",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    }
  }
};

// Variant overrides
window.__WWAI__.WWAI_PRODUCT_VARIANT_OVERRIDES = {
  "dr_idriss_pdp_jy6D4Q": {
    "major-fade-solution-system-sticky": {
      "major-fade-solution-system": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "major-fade-solution-system": {
      "major-fade-solution-system": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  },
  "dr_idriss_products_XFRGCN": {
    "the-depuffer-arnica-roll-on-serum": {
      "the-depuffer-arnica-roll-on-serum": {
        "1.35 oz / 40 mL": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "soft-wash": {
      "soft-wash": {
        "5.2 oz / 154 mL": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "barrier-baste-lip-basting-duo": {
      "barrier-baste-lip-basting-duo": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  }
};

// Labeled images
window.__WWAI__.WWAI_LABELED_IMAGES = {};

// Action buttons
window.__WWAI__.WWAI_ACTION_BUTTONS = {};